module.exports = __webpack_public_path__ + "img/egg-5.8779635e.jpg";